import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {Game} from "../Game";

const API = "https://api.bgc.ugarstudio.com/games";

export const fetchGames = createAsyncThunk("games/fetchAll", async () => {
    const res = await fetch(API);
    if (!res.ok) throw new Error("Failed to fetch games");
    return (await res.json()) as Game[];
});

export const fetchGame = createAsyncThunk("games/fetchOne", async (id: string) => {
    const res = await fetch(`${API}/${id}`);
    if (!res.ok) throw new Error("Failed to fetch game");
    return (await res.json()) as Game;
});

interface GamesState {
    list: Game[];
    loading: boolean;
    error: string | null;
    current: Game | null;
    currentLoading: boolean;
    currentError: string | null;
}

const initialState: GamesState = {
    list: [],
    loading: false,
    error: null,
    current: null,
    currentLoading: false,
    currentError: null,
};

const gamesSlice = createSlice({
    name: "games",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGames.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGames.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(fetchGames.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message ?? "Unknown error";
            })
            .addCase(fetchGame.pending, (state) => {
                state.currentLoading = true;
                state.currentError = null;
                state.current = null;
            })
            .addCase(fetchGame.fulfilled, (state, action) => {
                state.currentLoading = false;
                state.current = action.payload;
            })
            .addCase(fetchGame.rejected, (state, action) => {
                state.currentLoading = false;
                state.currentError = action.error.message ?? "Unknown error";
            });
    },
});

export default gamesSlice.reducer;
